import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'

const StatusPopup = ({ showStatusPopup, setStatusData, icon, title }) => {

    useEffect(() => {
        if (showStatusPopup) {
            const timer = setTimeout(() => {
                setStatusData((prev) => ({
                    ...prev,
                    showStatusPopup: false
                }));
            }, 5000);

            return () => clearTimeout(timer);
        }
    }, [showStatusPopup, setStatusData]);

    const handleOverlayClick = (e) => {
        if (e.target.classList.contains('popup')) {
            setStatusData((prev) => ({
                ...prev,
                showStatusPopup: false
            }));
        }
    };

    return (
        <div
            className={`popup ${showStatusPopup ? "show" : ""}`}
            onClick={handleOverlayClick}
        >
            <div className='popup-box custom-modal-box'>
                <Link to="" onClick={() => setStatusData((prev) => ({
                    ...prev,
                    showStatusPopup: false
                }))} className='close_popup_custom'>
                    <img src='https://www.svgrepo.com/show/499592/close-x.svg' />
                </Link>
                <div className='custom-modal-box-inner'>
                    <img src={icon === "success" ? 'https://cdn-icons-png.flaticon.com/512/7518/7518748.png' : "https://cdn-icons-png.flaticon.com/256/6659/6659895.png"} />
                    <h4>{title}</h4>
                </div>
            </div>
        </div>
    )
}

export default StatusPopup